import { upperFirst } from './string';
/**
 * @param {string} prefix
 * @param {string} value
 */

var prefixPropName = function prefixPropName(prefix, value) {
  return prefix + upperFirst(value);
};

export default prefixPropName;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/prefix-prop-name.js
// module id = 49
// module chunks = 0 1 2 3 4 5 6 7